import React, { Component } from "react";

import { Empty } from "antd";

import * as handler from "../components/utils/handler";

import Container from "../components/container/container";
import Content from "../components/container/content/content";
import ModalHead from "../components/modal-head/modalHead";
import Card from "../components/utils/card";

class TicketCalled extends Component {
  state = { lang: {} };
  UI = window["app-config"].ui;
  componentDidMount() {
    this.setState({ lang: handler.setTranslations() });
    handler.blinkText("#blink");
  }

  render() {
    let ticket_number = "";
    let branch = "";
    if (
      JSON.parse(localStorage.getItem("prevState")) !== null ||
      JSON.parse(localStorage.getItem("prevCheckedInData")) !== null
    ) {
      ticket_number =
        JSON.parse(localStorage.getItem("prevState")) !== null
          ? JSON.parse(localStorage.getItem("prevState")).response.data
              .ticket_info !== undefined
            ? JSON.parse(localStorage.getItem("prevState")).response.data
                .ticket_info.ticket_no
            : JSON.parse(localStorage.getItem("prevState")).response.data
                .ticket_number_f
          : JSON.parse(localStorage.getItem("prevCheckedInData"))
              .issueTicketResponse.data.ticket_info.ticket_no;

      return (
        <Container>
          <ModalHead heading={this.state.lang.StaticHeaderHeading} />
          <h4
            style={{
              textAlign: "center",
              marginLeft: "20px",
              color: this.UI.ticketCalledScreen.fColor,
            }}
          >
            {this.state.lang.TicketCalledHeading}
          </h4>
          <Content>
            <div style={{ margin: "10px auto" }}>
              <Card
                height="200px"
                width="200px"
                backgroundColor={this.UI.ticketCalledScreen.cardBgColor}
              >
                <h1
                  id="blink"
                  style={{
                    position: "fixed",
                    marginLeft: "32px",
                    marginTop: "10px",
                    color: this.UI.ticketCalledScreen.fColor,
                  }}
                >
                  {ticket_number}
                </h1>
              </Card>
            </div>
          </Content>
        </Container>
      );
    } else {
      return (
        <Container>
          <ModalHead heading={this.state.lang.StaticHeaderHeading} />
          <Content>
            <Empty description={this.state.lang.NoData} />
          </Content>
        </Container>
      );
    }
  }
}

export default TicketCalled;
